import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import * as css from './UnauthorizedWhatsApp.css';
import Btn from '../../../component/button/btn/Btn';
import {STATIC_IMAGE} from '../../../config/config';
import WhatsAppPricingPopup from '../../../component/whatsappPricingPopup/WhatsAppPricingPopup';
import useShow from '../../../hooks/useShow';
import AccountRolePermission from '../../components/rolePermission/AccountRolePermission';
import {bounceMessage} from '../../../layout/userMessages/UserMessage';
import {hasAccountRoleAccess} from '../../../functions/permission';
import {updateWhatsAppMessageSetting} from '../../eventSettings/settingItem/settingsItemFunctions';
import {useBrandingParams} from '../../../hooks/useBrandingParams';

interface UnauthorizedWhatsAppProps {
  onJoinClick?: () => void;
  className?: string;
}

const UnauthorizedWhatsApp: React.FC<UnauthorizedWhatsAppProps> = ({
    onJoinClick,
    className,
}) => {
    const {t} = useTranslation('branding');
    const whatsappPricingShow = useShow();
    const whatsAppMessageSetting = useSelector((s: any) => s.event.settings?.ticketsMailing?.whatsAppMessage);
    const whatsAppPermission = useSelector((s: any) => s.account.permissions?.find(item => item.permission === 'whatsApp'));
    const {messageType} = useBrandingParams();

    const handleJoinClick = async () => {
        const hasRoleAccess = hasAccountRoleAccess('manage package');
        if(!hasRoleAccess) {
            bounceMessage(t('inactivePermission'), 'attention');
            return;
        }      
        // If account WhatsApp permission status is 1, just update the event setting
        if(whatsAppPermission?.status === 1) {
            if(whatsAppMessageSetting === false || whatsAppMessageSetting === 0) {
                updateWhatsAppMessageSetting(whatsAppMessageSetting, messageType);
            }
        } else {
            // If account permission is not 1, show pricing popup
            whatsappPricingShow.open();
        }
        if(onJoinClick) {
            onJoinClick();
        }
    };

    return (
        <>
            <css.container className={className}>
                <css.image
                    src={`${STATIC_IMAGE}/app/mailing/whatsApp.png`}
                    alt={t('unauthorizedWhatsApp.altText')}
                />
                <css.description>{t('unauthorizedWhatsApp.description')}</css.description>
                <Btn className="yellow" onClick={handleJoinClick} >
                    {whatsAppPermission?.status === 1 ? t('unauthorizedWhatsApp.enableWhatsApp') : t('unauthorizedWhatsApp.joinNow')}
                </Btn>
            </css.container>
            <AccountRolePermission rolePermission="owner" views={['manager']}>
                {whatsappPricingShow.isOpen && whatsAppPermission?.status !== 1 && (
                    <WhatsAppPricingPopup 
                        show={whatsappPricingShow}
                    />
                )}
            </AccountRolePermission>
        </>
    );
};

export default UnauthorizedWhatsApp;
